module.exports = __webpack_public_path__ + "src/img/kaoping_on.819640fa.svg";